/** @license React v1.4.0
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

var e = require("object-assign"),
    g = require("react");

exports.useSubscription = function (a) {
  var c = a.getCurrentValue,
      d = a.subscribe,
      b = g.useState(function () {
    return {
      getCurrentValue: c,
      subscribe: d,
      value: c()
    };
  });
  a = b[0];
  var f = b[1];
  b = a.value;
  if (a.getCurrentValue !== c || a.subscribe !== d) b = c(), f({
    getCurrentValue: c,
    subscribe: d,
    value: b
  });
  g.useDebugValue(b);
  g.useEffect(function () {
    function b() {
      if (!a) {
        var b = c();
        f(function (a) {
          return a.getCurrentValue !== c || a.subscribe !== d || a.value === b ? a : e({}, a, {
            value: b
          });
        });
      }
    }

    var a = !1,
        h = d(b);
    b();
    return function () {
      a = !0;
      h();
    };
  }, [c, d]);
  return b;
};